import { FaHome, FaSearch, FaHeart, FaUsers } from "react-icons/fa";

export default function About() {
    return (
        <div className="page">
            <div className="container">

                <h1>About Washington AFH</h1>

                <p className="subtitle">
                    Helping families discover trusted Adult Family Homes across Washington State.
                </p>

                {/* FEATURE CARDS */}
                <div className="feature-grid">

                    <div className="feature-card">
                        <FaSearch className="feature-icon" />
                        <h3>Search Homes</h3>
                        <p>
                            Browse Adult Family Homes by city, care needs, and availability.
                        </p>
                    </div>

                    <div className="feature-card">
                        <FaHome className="feature-icon" />
                        <h3>Compare Listings</h3>
                        <p>
                            View photos, pricing, and amenities to find the right home.
                        </p>
                    </div>

                    <div className="feature-card">
                        <FaHeart className="feature-icon" />
                        <h3>Trusted Care</h3>
                        <p>
                            Connect with homes dedicated to safe and compassionate care.
                        </p>
                    </div>

                    <div className="feature-card">
                        <FaUsers className="feature-icon" />
                        <h3>Support Families</h3>
                        <p>
                            Helping families make confident decisions about long-term care.
                        </p>
                    </div>

                </div>

                {/* MISSION */}
                <section className="about-section">
                    <h2>Our Mission</h2>
                    <p>
                        Washington AFH makes it easier to find quality Adult Family Homes.
                        Families can explore homes, compare services, and connect directly
                        with providers in a safe and simple way.
                    </p>
                </section>

            </div>
        </div>
    );
}